// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "customer-261021-36/static/css/" + chunkId + "." + {"1236":"21ca9315","1670":"21ca9315","2395":"29a0edac","2425":"29a0edac","2982":"33c84e52","3006":"21ca9315","3137":"29a0edac","7951":"29a0edac","8903":"21ca9315"}[chunkId] + ".chunk.css";
};